import { instance, service } from './instance'



const apiPrefix = service === 'glo' ? '/admin-dashboard' : '/admin';

interface QueryParams {
  activeTimeLine: string;
  network: string;
  startDate: string;
  endDate: string;
  analyticsChartFilter: string;
  pageNumber: number;
  pageSize: number;
  searchTerm: string;
}
interface RevenueCardQueryParams {
  activeTimeLine: string;
  network: string;
  startDate: string;
  endDate: string;
  analyticsChartFilter: string;

}

export const api = {
  getAnalyticsCardData: ({activeTimeLine, network, startDate, endDate,  analyticsChartFilter}:RevenueCardQueryParams): Promise<any> =>
    instance
      .get(`${apiPrefix}/analytics?interval=${activeTimeLine}&network=${network}&startDate=${startDate}&endDate=${endDate}&subscription_chart_filter=${analyticsChartFilter}`)
      .then(({ data }) => data),
}
